import { Card } from '@/components/ui/card';
import DateRangePicker from '@/components/filters/DateRangePicker';

const RenewalsPage = () => (
  <div className="space-y-6">
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div>
        <h2 className="text-2xl font-semibold text-white">Renewals</h2>
        <p className="text-sm text-slate-400">Monitor upcoming renewals, failed payments, and automated dunning.</p>
      </div>
      <DateRangePicker />
    </div>

    <Card title="Upcoming Renewals">
      <p className="text-sm text-slate-400">Use filters for 7/30/90 day view; integrate TanStack Table with Supabase RPC.</p>
    </Card>

    <Card title="Dunning Queue">
      <p className="text-sm text-slate-400">Surface memberships with failed attempts and quick retry actions.</p>
    </Card>
  </div>
);

export default RenewalsPage;
